
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/context-hub/business-context",
      function () {
        return require("private-next-pages/context-hub/business-context.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/context-hub/business-context"])
      });
    }
  